import React, { useMemo } from 'react';
import GPT, { useKeyOpinionPromptList } from '@op/components/GPT';

type AISummaryCardProps = {
  /** 过滤条件 */
  filter?: any;
  /** 游戏信息 */
  gameInfo?: any;
  /** 是否筛选器已变化 */
  isFilterChanged?: boolean;
  /** 保存名称 */
  saveName?: string;
  /** 是否 Steam */
  isSteam?: boolean;
  /** 渠道选项 */
  channelOption?: string;
  wholeGameInfo?: any;
  pageCardRef?: any;
  /** 从父组件传入的报告数据 */
  reportData?: any;
};

/**
 * AI 摘要卡片组件
 *
 * 用于展示 AI 生成的摘要内容，支持自动/手动触发请求
 * 包含前置统计数据请求逻辑
 */
export default function AISummaryCard({
  filter,
  isFilterChanged = true,
  saveName,
  wholeGameInfo,
  pageCardRef,
  reportData,
}: AISummaryCardProps) {
  const keyOpinionsPromptList = useKeyOpinionPromptList({
    gameInfo: wholeGameInfo,
  });

  /**
   * 前置请求映射配置
   * 使用父组件传入的 reportData，不再内部调用 fetchReport
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const requestFuncMap = useMemo(() => {
    if (!isFilterChanged) return undefined;

    return {
      defaultRequest: () => {
        return Promise.resolve(reportData);
      },
    };
  }, [isFilterChanged, reportData]);

  return (
    <GPT.PageCard
      ref={pageCardRef}
      filter={filter}
      showModelType={true}
      hasStopBtn={true}
      contentCard
      title={false}
      hideIcons={['refresh', 'copy', 'fullscreen']}
      requestFuncMap={requestFuncMap}
      autoRequest={false}
      promptList={keyOpinionsPromptList}
      linkFilterChange={false}
      saveName={saveName}
    >
      {(toggleVisible: any, { total }: { total: number }) => (
        <div className="gpt-summary-entry-tips">
          <GPT.Button
            disabled={total <= 0}
            onClick={() => toggleVisible()}
          ></GPT.Button>
        </div>
      )}
    </GPT.PageCard>
  );
}

export type { AISummaryCardProps };
